<template>
  <div class="typeahead text-left">
    <input type="hidden" :name="fieldName" v-model="selectedItem.id" v-if="selectedItem" />
    <input
      type="text"
      v-model="searchTerm"
      class="sc-input"
      @focus="clearItem"
      @input="search"
      :id="id"
      autocomplete="off"
    />
    <div class="results" v-if="searching">
      <a
        v-for="item in items"
        href="#"
        :key="item.id"
        class="result"
        @click.prevent="select(item)"
      >{{ item.label }}</a>
    </div>
  </div>
</template>

<script>
import debounce from "debounce";

export default {
  props: [
    "fieldName",
    "searchFunc",
    "onChange",
    "initialSearch",
    "initialValue",
    "id"
  ],
  data: function() {
    return {
      selectedItem: this.initialValue,
      searchTerm: this.initialValue ? this.initialValue.label : "",
      items: [],
      searching: false
    };
  },
  methods: {
    select: function(item) {
      this.selectedItem = item;
      this.searchTerm = item.label;
      if (this.onChange) {
        this.onChange(item);
      }
      this.searching = false;
    },
    clearItem: function() {
      this.selectedItem = null;

      // If we want search to happen initially, do it here with a blank term.
      if (this.initialSearch) {
        this.search();
      }
    },
    search: debounce(async function() {
      this.searching = true;
      const results = await this.searchFunc(this.searchTerm);
      this.items = results;
    }, 300)
  }
};
</script>
